// Deterministic mapping: search-time generation_spec objectives -> lattice
// objective preselect. LLM never touches this (architecture rule).
const MAP = [
  { property: 'tensile_strength', modes: ['maximize', '>='], target: 'crush_strength' },
  { property: 'bulk_modulus', modes: ['maximize', '>='], target: 'stiffness_to_weight' },
  { property: 'thermal_conductivity', modes: ['minimize', '<='], target: 'heat_insulation' },
];

export function preselectObjective(objectives) {
  for (const obj of objectives || []) {
    const hit = MAP.find(
      (m) => m.property === obj?.property && m.modes.includes(String(obj?.mode || '').toLowerCase())
    );
    if (hit) return hit.target;
  }
  return null;
}
